import { render, staticRenderFns } from "./OnRatiosEmplois.vue?vue&type=template&id=0c2c060d&"
import script from "./OnRatiosEmplois.vue?vue&type=script&lang=js&"
export * from "./OnRatiosEmplois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports